import * as Highcharts from 'highcharts';
import * as _ from 'underscore';
import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
@Component({
	selector: 'app-venue-type',
	templateUrl: './venue-type.component.html',
	styleUrls: ['./venue-type.component.css']
})
export class VenueTypeComponent implements OnInit, WidgetCore, OnDestroy {
	@ViewChild('graphArea', { static: true }) graphElement: ElementRef;

	@ViewChild('childGraphArea', { static: true }) ChildGraphElement: ElementRef;

	@Input() key: string;
	@Input() iscustomendpoint: any;
	@Input() queryorderby: any;
	@Input() downloadconfig: any;
	@Input() downloadcsvcolumns: any;
	@Input() sectionclass: any;
	@Input() chartconfiguration: any;

	public reloadSubscription;
	public widgetDataSubscription;
	public hasData = true;
	public hasChildVenueData = false;
	public showLoad = false;
	public columns: any[];
	public venueTypeCategories: string[] = [];
	public venueTypeData: { y: number; color: string; parent_id: number }[] = [];
	public childVenueTypeData: { name: string; y: number; color: string }[] = [];
	public childVenueTypeTitle: string;
	public downloadIcon: string = '../../../../../assets/images/Download_Icon_R7.svg';
	public downloadConfiguration: DownloadConfig;
	public downloadCSVColumns: any;
	public isR101_R104: boolean = false;
	public isR104: boolean = false;
	public isR13: boolean = false;
	public isR1301: boolean = false;
	public isR1101: boolean = false;
	public isR103: boolean = false;
	public isEntravision_R103: boolean = false;
	public chartConfig: any;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.queryorderby = this.queryorderby ? JSON.parse(decodeURI(this.queryorderby)) : [];
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.downloadCSVColumns = this.downloadcsvcolumns ? JSON.parse(decodeURI(this.downloadcsvcolumns)) : [];
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.isR101_R104 =
			this.analyticsDataModel.config.directoryName == 'default-r101' ||
			this.analyticsDataModel.config.directoryName == 'default-r104';
		this.isR104 = this.analyticsDataModel.config.directoryName == 'default-r104';
		this.isR13 =
			this.analyticsDataModel.config.directoryName.toLocaleLowerCase() === 'lee-r13' ||
			this.analyticsDataModel.config.directoryName.toLocaleLowerCase() === 'default-r13'
				? true
				: false;
		this.isR1301 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r1301';
		this.isR1101 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r1101';
		this.isR103 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'default-r103';
		this.isEntravision_R103 = this.analyticsDataModel.config.directoryName.toLocaleLowerCase() == 'entravision-r103';
		this.chartConfig = JSON.parse(decodeURI(this.chartconfiguration));
		this.requestData();
	}

	requestData(): void {
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				if (response.success) {
					this.hasData = true;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
				this.showLoad = false;
			});
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
	}

	processResponseData(response): void {
		this.venueTypeCategories = [];
		this.venueTypeData = [];
		response.forEach((item) => {
			this.venueTypeCategories.push(this.isR101_R104 ? item.category_name.split(' ').join('<br>') : item.category_name);
			this.venueTypeData.push({ y: item.impressions, color: item.color_code, parent_id: item.id });
		});
		this.generateChartObj();
	}

	generateChartObj(): void {
		let tooltip: any;
		if (this.isR103 || this.isEntravision_R103) {
			tooltip = {
				useHTML: true,
				style: {
					fontWeight: '400',
					fontSize: '12px',
					fontFamily: 'Rubik'
				},
				formatter: function (): string {
					return `${this.key}: ${this.y.toLocaleString()} Impressions`;
				}
			};
		} else if (this.isR13 || this.isR1301) {
			tooltip = {
				useHTML: true,
				formatter: function (): string {
					return `${this.key}: ${this.y.toLocaleString()} Impressions`;
				}
			};
		} else if (this.isR1101) {
			tooltip = {
				useHTML: true,
				backgroundColor: '#E7E7E7',
				borderColor: '#E7E7E7',
				borderRadius: 5,
				shadow: false,
				style: {
					color: '#343434',
					fontWeight: '700',
					fontSize: '12px',
					fontFamily: 'Karla'
				},
				formatter: function (): string {
					return `<div class="tooltip-key">${
						this.key
					}</div><div class="tooltip-helper">${this.y.toLocaleString()} Impressions</div> `;
				}
			};
		} else {
			tooltip = {
				backgroundColor: '#333333',
				borderColor: '#333333',
				borderRadius: this.isR104 ? 10 : 5,
				followPointer: false,
				style: {
					color: '#FFFFFF',
					fontWeight: '400',
					fontSize: '12px',
					fontFamily: 'Roboto'
				},
				useHTML: true,
				formatter: function (): string {
					return `<span class="tooltip-key">${
						this.key
					}</span><span class="tooltip-helper">:</span> ${this.y.toLocaleString()} Impressions`;
				}
			};
		}

		// tslint:disable-next-line: no-this-assignment
		Highcharts.chart(this.graphElement.nativeElement, {
			chart: {
				type: 'column',
				marginTop: this.chartConfig?.seriesConfig?.[0].marginTop ?? null,
				height: this.isR101_R104 ? 230 : this.chartConfig?.height ?? null,
				marginLeft:
					this.isR103 || this.isEntravision_R103 ? 150 : this.chartConfig?.seriesConfig?.[0].marginLeft ?? null,
				marginRight:
					this.isR103 || this.isEntravision_R103 ? 150 : this.chartConfig?.seriesConfig?.[0].marginRight ?? null,
				marginBottom: this.chartConfig?.seriesConfig?.[0].marginBottom ?? null
			},
			title: {
				text: ''
			},
			xAxis: {
				categories: this.venueTypeCategories,
				labels: {
					rotation: this.isR101_R104 ? 0 : this.chartConfig?.seriesConfig?.[0].rotation ?? undefined,
					style: this.chartConfig?.seriesConfig?.[0].style ?? {}
				}
			},
			yAxis: {
				title: this.chartConfig?.seriesConfig?.[0].yAxis?.title
					? this.chartConfig?.seriesConfig?.[0].yAxis?.title
					: {
							text: 'Impressions'
					  },
				allowDecimals: false
			},
			tooltip: tooltip,
			plotOptions: {
				bar: {
					grouping: false
				},
				column: {
					borderRadius: this.chartConfig?.seriesConfig?.[0]?.borderRadius ?? 0
				},
				series: {
					cursor: 'pointer',
					events: {
						click: function (venueType) {
							this.requestChildVenueTypeData(venueType.point.parent_id);
						}.bind(this),
						legendItemClick: function (e) {
							e.preventDefault();
						}
					}
				}
			},
			legend: this.chartConfig?.seriesConfig?.[0].legend
				? this.chartConfig.seriesConfig[0].legend
				: {
						enabled: false
				  },
			series: [
				{
					name: 'Impressions',
					maxPointWidth: this.chartConfig?.seriesConfig?.[0]?.pointWidth ?? 50,
					type: 'column',
					data: this.venueTypeData
				}
			]
		});
	}

	requestChildVenueTypeData(parentId): void {
		this.showLoad = true;
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key, null, null, null, null, null, parentId)
			.subscribe((response: any) => {
				if (response.success) {
					this.hasChildVenueData = true;
					this.processChildVenueTypeResponseData(response.data);
				} else {
					this.hasChildVenueData = false;
				}
				this.showLoad = false;
			});
	}
	processChildVenueTypeResponseData(response): void {
		var defaultColor = {
			Transit: '#3B82F6',
			Airports: '#D97706',
			Buses: '#0284C7',
			'Taxi & Rideshare TV': '#7C3AED',
			'Taxi & Rideshare Top': '#DB2777',
			Subway: '#EA580C',
			'Train Stations': '#DC2626',
			Ferry: '#2DD4BF',
			Retail: '#D97706',
			'Fueling Stations': '#059669',
			'Convenience Stores': '#0284C7',
			Grocery: '#7C3AED',
			'Liquor Stores': '#DB2777',
			Mall: '#EA580C',
			'Cannabis Dispensaries': '#DC2626',
			Pharmacies: '#2DD4BF',
			'Parking Garages': '#93C5FD',
			Outdoor: '#EA580C',
			Billboards: '#D97706',
			'Urban Panels': '#0284C7',
			'Bus Shelters': '#7C3AED',
			'Health & Beauty': '#DB2777',
			Gyms: '#D97706',
			Salons: '#0284C7',
			Spas: '#7C3AED',
			'Point of Care': '#DC2626',
			Education: '#4F46E5',
			'Doctors Offices': '#D97706',
			'Veterinary Offices': '#0284C7',
			Schools: '#D97706',
			'Colleges and Universities': '#0284C7',
			'Office Buildings': '#D97706',
			Leisure: '#0284C7',
			'Recreational Locations': '#D97706',
			'Movie Theaters': '#0284C7',
			'Sports Entertainment': '#7C3AED',
			Bars: '#DB2777',
			'Casual Dining': '#EA580C',
			QSR: '#DC2626',
			Hotels: '#2DD4BF',
			'Golf Carts': '#0284C7',
			'Night Clubs': '#0D9488',
			'High-End Dining': '#059669',
			Government: '#7C3AED',
			DMVs: '#D97706',
			'Military Bases': '#0284C7',
			'Post Offices': '#DB2777',
			Financial: '#059669',
			Banks: '#D97706',
			Residential: '#2DD4BF',
			'Apartment Buildings and Condominiums': '#D97706'
		};

		this.childVenueTypeData = [];
		response.forEach((item) => {
			this.childVenueTypeTitle = item.category_name;
			this.childVenueTypeData.push({
				name: item.child_category_name,
				y: item.impressions,
				color: defaultColor[item.child_category_name] ? defaultColor[item.child_category_name] : null
			});
		});
		this.generateChildChartObj();
	}

	generateChildChartObj(): void {
		if (this.chartConfig?.seriesConfig?.[0]?.halfDonut) {
			// tslint:disable-next-line: no-this-assignment
			Highcharts.chart(this.ChildGraphElement.nativeElement, {
				chart: {
					width: this.isR101_R104 ? 850 : this.chartConfig?.seriesConfig?.[0]?.svgWidth ?? 563,
					plotBackgroundColor: null,
					marginLeft: this.chartConfig?.seriesConfig?.[0]?.marginLeft ?? null,
					plotBorderWidth: null,
					plotShadow: false,
					type: 'pie'
				},
				title: {
					text: this.childVenueTypeTitle,
					align: this.chartConfig?.seriesConfig?.[0]?.titleAlign
						? this.chartConfig?.seriesConfig?.[0]?.titleAlign
						: 'center'
				},
				tooltip: this.isR1301
					? {
							useHTML: true,
							formatter: function (): string {
								return `<span style="color: ${this.color}">${
									this.key
								}</span>&nbsp;&nbsp;&nbsp;&nbsp; ${this.percentage.toFixed(1)}%`;
							}
					  }
					: {
							useHTML: true,
							formatter: function (): string {
								return `${this.key}&nbsp;&nbsp;&nbsp;&nbsp; ${this.percentage.toFixed(1)}%`;
							}
					  },
				legend: {
					align: 'right',
					verticalAlign: 'middle',
					layout: 'vertical',
					padding: 20,
					itemMarginTop: 5,
					itemMarginBottom: 5,
					labelFormatter: function (): string {
						return `${this.name}: ${this['percentage'].toFixed(1)}%`;
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						borderWidth: 0,
						showInLegend: true,
						dataLabels: {
							enabled: false
						},
						point: {
							events: {
								click: null
							}
						},
						innerSize: this.isR101_R104 ? '75%' : this.chartConfig?.seriesConfig?.[0]?.innerSize ?? '0%'
					},
					series: {
						states: {}
					}
				},
				series: [
					{
						center: ['25%', null],
						events: {
							click: function (e) {
								e.preventDefault();
							}
						},
						type: 'pie',
						innerSize: '46%',
						startAngle: -90,
						endAngle: 90,
						data: this.childVenueTypeData
					}
				]
			});
		} else {
			let tooltip: any;
			if (this.isR1101) {
				tooltip = {
					useHTML: true,
					backgroundColor: '#E7E7E7',
					borderColor: '#E7E7E7',
					borderRadius: 5,
					shadow: false,
					followPointer: false,
					style: {
						color: '#343434',
						fontWeight: '700',
						fontSize: '12px',
						fontFamily: 'Karla'
					},
					formatter: function (): string {
						return `<div class="tooltip-key">${
							this.key
						}</div><div class="tooltip-helper">${this.y.toLocaleString()} Impressions</div> `;
					}
				};
			} else {
				tooltip = {
					shadow: false,
					backgroundColor: '#333333',
					borderColor: '#333333',
					borderRadius: this.isR104 ? 10 : 5,
					followPointer: false,
					style: {
						color: '#FFFFFF',
						fontWeight: '400',
						fontSize: '12px',
						fontFamily: 'Roboto'
					},
					useHTML: true,
					formatter: function (): string {
						return `<span class="tooltip-key">${
							this.key
						}</span><span class="tooltip-helper">:</span> ${this.y.toLocaleString()} Impressions`;
					}
				};
			}
			// tslint:disable-next-line: no-this-assignment
			Highcharts.chart(this.ChildGraphElement.nativeElement, {
				chart: {
					width: this.isR101_R104 ? 850 : this.chartConfig?.seriesConfig?.[0]?.svgWidth ?? 563,
					plotBackgroundColor: null,
					marginLeft: this.chartConfig?.seriesConfig?.[0]?.marginLeft ?? null,
					plotBorderWidth: null,
					plotShadow: false,
					spacingRight: this.chartConfig?.seriesConfig?.[0]?.spacingRight ?? 0,
					type: 'pie'
				},
				title: {
					text: this.childVenueTypeTitle,
					x: this.chartConfig?.seriesConfig?.[0]?.xAxis?.title?.x ?? 0
				},
				tooltip:
					this.isR103 || this.isEntravision_R103
						? {
								style: {
									fontWeight: '400',
									fontSize: '12px',
									fontFamily: 'Rubik'
								},
								useHTML: true,
								formatter: function (): string {
									return `${this.key}: ${this.y.toLocaleString()} Impressions`;
								}
						  }
						: tooltip,
				legend: {
					align: 'right',
					verticalAlign: 'middle',
					layout: 'vertical',
					padding: 3,
					margin: this.isR1101 ? 200 : 12,
					itemMarginTop: 5,
					itemMarginBottom: 5,
					symbolPadding: this.chartConfig?.seriesConfig?.[0]?.symbolPadding ?? 5,
					x: this.chartConfig?.seriesConfig?.[0]?.x ?? null,
					labelFormatter: function (): string {
						return `${this.name}: ${this['percentage'].toFixed(1)}%`;
					}
				},
				plotOptions: {
					pie: {
						allowPointSelect: true,
						cursor: 'pointer',
						borderWidth: 0,
						showInLegend: true,
						dataLabels: {
							enabled: false
						},
						point: {
							events: {
								click: null
							}
						},
						innerSize: this.isR101_R104 ? '75%' : this.chartConfig?.seriesConfig?.[0]?.innerSize ?? '0%'
					},
					series: {
						states: {
							hover: {
								enabled: false
							},
							inactive: {
								opacity: 1
							}
						}
					}
				},
				series: [
					{
						events: {
							click: function (e) {
								e.preventDefault();
							}
						},
						type: 'pie',
						data: this.childVenueTypeData
					}
				]
			});
		}
	}

	downloadDataInCSV(e: any): void {
		e.preventDefault();
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName,
			this.downloadCSVColumns
		);
	}
}
